<template>
  <section class="app-cookie-policy-manager-option">
    <header class="cpmo-header">
      <div class="cpmo-title-wrapper">
        <span class="cpmo-expand-handler">
          <AppPlusIcon v-if="!showDescription" class="cpmo-expand-handler__icon" />
          <AppMinusIcon v-else class="cpmo-expand-handler__icon" />
        </span>
        <h6 :id="titleId" class="cpmo-title">{{ header }}</h6>
        <button
          :aria-expanded="showDescription"
          :aria-controls="descriptionId"
          :aria-labelledby="titleId"
          class="cpmo-expand-btn"
          type="button"
          @click="showDescription = !showDescription"
        />
      </div>

      <span class="cpmo-action">
        <span v-if="alwaysOn" class="cpmo-always-on">Always on</span>
        <label v-else class="cpmo-switch">
          <span class="cpmo-switch__label">{{ vModel ? 'On' : 'Off' }}</span>

          <input v-model="vModel" class="visually-hidden" type="checkbox" />
          <AppCookiePolicyManagerOptionSwitcher :value="vModel" />
        </label>
      </span>
    </header>

    <CollapseTransition :duration="200">
      <p v-if="showDescription" :id="descriptionId" class="cpmo-description">
        {{ description }}
      </p>
    </CollapseTransition>
  </section>
</template>

<script>
import CollapseTransition from '@/components/transitions/CollapseTransition.vue';
import AppMinusIcon from '@/components/icons/AppMinusIcon.vue';
import AppPlusIcon from '@/components/icons/AppPlusIcon.vue';
import AppCookiePolicyManagerOptionSwitcher from '@/components/AppCookiePolicyManagerOptionSwitcher.vue';

export default {
  name: 'AppCookiePolicyManagerOption',
  components: { AppCookiePolicyManagerOptionSwitcher, AppMinusIcon, AppPlusIcon, CollapseTransition },
  props: {
    id: {
      type: String,
      required: true,
    },
    alwaysOn: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showDescription: false,
    };
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    descriptionId() {
      return `cpmo-${this.id}-description`;
    },
    titleId() {
      return `cpmo-${this.id}-title`;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-cookie-policy-manager-option {
  .cpmo-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .cpmo-title-wrapper {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 8px;
    position: relative;
  }

  .cpmo-expand-btn {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .cpmo-expand-handler {
    box-sizing: content-box;
    width: 10px;
    height: 10px;
    padding: 3px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 12px;

    &__icon {
      width: 100%;
      height: 100%;
    }
  }

  .cpmo-title,
  .cpmo-switch {
    margin-bottom: 0;
  }

  .cpmo-title {
    flex: 1;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  .cpmo-always-on {
    font-size: 14px;
  }

  .cpmo-switch {
    display: flex;
    align-items: center;
    gap: 8px;

    &__label {
      font-size: 14px;
      text-transform: uppercase;
    }

    input {
      margin: 0;
    }
  }

  .cpmo-description {
    margin-top: 12px;
    padding-left: 16px;
    font-size: 14px;
    line-height: 1.5;
    color: vars.$c-dark-5b;
  }
}
</style>
